<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents">
        <div class="news_wrap">
          <div class="path"><a href="javascript:void(0);" @click="$router.go(-1)">◀ 목록가기</a></div>

          <!-- view -->
          <div class="news-view">
            <div class="view-title">[ 공지사항 ] {{noticeInfo.newsCenterTitle}}</div>
            <div class="attatched-image ta-left" v-if="noticeInfo.attaFileSeq">
              <!-- <img :src="'/api/main/bbs/noticeImage?attaFileSeq='+noticeInfo.attaFileSeq" :alt="noticeInfo.attaFileNm" /> -->
              <ImageComp :src="'/api/main/bbs/newsCenterImage?attaFileSeq='+noticeInfo.attaFileSeq" alt="공지사항 이미지"/>
            </div>
            <div v-if="noticeInfo.newsCenterCont" class="ql-snow">
                <div class="view-text ql-editor">
                    <QuillContentViewer
                      :contentData="noticeInfo.newsCenterCont"
                      :metaDataYn="true"
                      @metaDataReady="handleMetaData"
                    />
                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { noticeDetailMeta } from '@/utils/meta';
import QuillContentViewer from '@/components/QuillContentViewer.vue';

export default {
    components: { QuillContentViewer },
    data() {
        return {
            newsCenterSeq : this.$route.query.no || '',
            noticeInfo : {
                attaFileSeq : '',
                attaFileNm : '',
                newsCenterTitle : '',
                newsCenterCont : '',
            },

             metaContData : '',
             blobUrls: []  // 생성된 blob URL들을 추적 (메모리 해제용)
        }
    }, 

    beforeMount() {
        this.getNoticeDetail();
    },

    methods : {
        getNoticeDetail() {
            this.$.httpPost('/api/main/bbs/getNoticeDetail', {newsCenterSeq: this.newsCenterSeq})
            .then(res=>{
                    this.noticeInfo = res.data.info;

            }).catch(this.$.httpErrorCommon);
        },

        handleMetaData(metaData) {
            this.metaContData = metaData;
        }
    },

    metaInfo() {
      return noticeDetailMeta(this.noticeInfo.newsCenterTitle, this.metaContData);
    }
}
</script>